<template>
  <main>
    <header-view>{{ $t('titles.nutritions') }}</header-view>

    <!-- 营养素状态图 -->
    <AlgorithmValueNotice />
    <waterfall-card
        v-if="nutritionStatus.length > 0"
        :title="$t('dataOverview.nutritionStatusChart')"
        :list="nutritionStatus"
        labelKey="item_dict_name_simple"
        colorKey="color"
        :valueKey="statusValueKey"
    ></waterfall-card>

    <!-- 详细数据报告表 -->
    <table-card :title="$t('dataOverview.detailedDataReportTable')" :columns="columns" :list="list" custom v-slot="row">
      <router-link :to="{ path: '/nutrition', query: { code: row.system_code, title: row.item_dict_name, ...routeQuery } }"></router-link>
    </table-card>

    <list-card :title="$t('dataOverview.nutritionConditioningAdvice')" :list="nutritions" titleKey="item_dict_name" contentKey="condition_content"></list-card>
  </main>
</template>

<script>
  import HeaderView from "@/components/HeaderView";
  import WaterfallCard from "@/components/WaterfallCard";
  import TableCard from "@/components/TableCard";
  import ListCard from "@/components/ListCard";
  import {getReportLoopItemNutritionAll} from "../net/api";
  import { routeLanguageMixin } from "@/utils/routeLanguageHelper";

  /**
   * 营养素概览
   */
  export default {
    name: "Nutritions",
    mixins: [routeLanguageMixin],
    components: {ListCard, TableCard, WaterfallCard, HeaderView},

    data() {
      return {
        packageNo: '',
        checkcode: '',
        rand: '',

        // 通用态图列表数据关联项
        statusValueKey: {},

        // 营养素状态图
        nutritionStatus: [],

        // 列表关联项
        columns: {},
        list: [],

        nutritions: []
      }
    },

    computed: {
      // 基础参数数据
      query() {
        return {
          packageNo: this.packageNo, rand: this.rand,  checkcode: this.checkcode
        }
      }
    },

    watch: {
      // 监听语言变化，重新初始化国际化数据
      '$i18n.locale'() {
        this.initializeI18nData();
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;

      // 初始化国际化数据对象
      this.initializeI18nData();

      this.syncPageData();
    },

    methods: {
      // 初始化国际化数据对象
      initializeI18nData() {
        // 通用态图列表数据关联项
        this.statusValueKey = {
          av: this.$t('dataOverview.averageValue')
        };

        // 列表关联项
        this.columns = {
          item_dict_name: this.$t('dataOverview.detectionItem'),
          av: this.$t('dataOverview.averageValue')
        };
      },

      // 同步页面数据
      syncPageData() {
        // 获取报告数据
        getReportLoopItemNutritionAll({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode
        }).then((data) => {
          this.nutritionStatus = data.show_zhuangtaitu;
          this.list = data.show_xiangxishuju;
          this.nutritions = data.show_tiaolijianyi;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
